import styled from "styled-components";

interface PropsButton {
  variant: string;
  size: "sm" | "lg";
  startIcon: boolean;
  loading?: string;
  widthFull: boolean;
}

export const ButtonContent = styled.div`
  padding-left: 7.5px;
  padding-right: 7.5px;
`

export const Button = styled.button<PropsButton>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: ${(props) => props.theme.borderRadius};
  min-width: ${(props) => props.theme.minWidth};
  font-family: ${(props) => props.theme.fontFamily};
  font-size: ${(props) => props.theme.fontSize};
  font-weight: ${(props) => props.theme.fontWeight};
  line-height: ${(props) => props.theme.lineHeight};
  text-align: ${(props) => props.theme.textAlign};
  background-color: ${(props) => props.theme[props.variant].backgroundColor};
  border: ${(props) => props.theme[props.variant].border};
  color: ${(props) => props.theme[props.variant].color};
  height: ${(props) => props.theme.sizes[props.size].height};
  padding: ${(props) => props.theme.sizes[props.size].padding};
  
  width: ${props => props.theme.widthFull};
  
  ${(props) => props.theme.motion};

  .label {
    display: flex;
    justify-content: center;
    align-items: center;
  }

    .icon {
      display: inline-flex;
      padding-right: ${(props) => props.theme.sizes[props.size].icon.paddingRight};
    }

  ${(props) =>
    !props.loading &&
    `
    &:hover {
      background-color: ${props.theme.states.hover.backgroundColor};
      border-color: ${props.theme.states.hover.borderColor};
      color: ${props.theme.states.hover.color};
    }
  `}
  &.focus-visible {
    ${(props) => props.theme.states.focus};
  }
  &:disabled {
    cursor: initial;
    background-color: ${(props) => props.theme.states.disabled.backgroundColor};
    border: ${(props) => props.theme.states.disabled.border};
    color: ${(props) => props.theme.states.disabled.color};
  }
  ${(props) => props.widthFull ? `width:100%;` : `width: auto;`}

  ${(props) =>
    props.loading &&
    `
    cursor: initial;
    border-radius: 50px;
    width: ${props.theme.sizes[props.size].height};
    min-width: 0;
    padding: 0;
    .label{
      display: none;
    }
  `}
`;
